// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import { CarouselController } from 'hyp_page_builder';
import ReminderComposeController from './reminder_compose_controller';
import PushSubscriptionController from './push_subscription_controller';
import ClipboardController from './clipboard_controller';
import DrawerController from './drawer_controller';
import ToolLauncherController from './tool_launcher_controller';
import AutoSubmitController from './auto_submit_controller';
import TimezoneController from './timezone_controller';
import TimerController from './time_tracker/timer_controller';
import TaskSuggestionsController from './time_tracker/task_suggestions_controller';
import EntryFormController from './time_tracker/entry_form_controller';
import ExportFormController from './time_tracker/export_form_controller';
import PollController from './time_tracker/poll_controller';
import LiveTotalsController from './time_tracker/live_totals_controller';

import BoardSortableController from './boards/board_sortable_controller';
import CardComposerController from './boards/card_composer_controller';
import FilterFormController from './boards/filter_form_controller';
import CardModalController from './boards/card_modal_controller';
import BoardScrollController from './boards/board_scroll_controller';
import CardSelectionController from './boards/card_selection_controller';
import LightboxController from './boards/lightbox_controller';
import AttachmentDropController from './boards/attachment_drop_controller';
import MarkdownEditorController from './boards/markdown_editor_controller';
import ListSortableController from './boards/list_sortable_controller';
import SelectNavigateController from './boards/select_navigate_controller';
import LabelColorController from './boards/label_color_controller';
import LabelPickerController from './boards/label_picker_controller';

application.register('carousel', CarouselController);
application.register('reminder-compose', ReminderComposeController);
application.register('push-subscription', PushSubscriptionController);
application.register('clipboard', ClipboardController);
application.register('drawer', DrawerController);
application.register('tool-launcher', ToolLauncherController);
application.register('auto-submit', AutoSubmitController);
application.register('timezone', TimezoneController);
application.register('timer', TimerController);
application.register('task-suggestions', TaskSuggestionsController);
application.register('entry-form', EntryFormController);
application.register('export-form', ExportFormController);
application.register('poll', PollController);
application.register('live-totals', LiveTotalsController);

application.register('board-sortable', BoardSortableController);
application.register('card-composer', CardComposerController);
application.register('filter-form', FilterFormController);
application.register('card-modal', CardModalController);
application.register('board-scroll', BoardScrollController);
application.register('card-selection', CardSelectionController);
application.register('lightbox', LightboxController);
application.register('attachment-drop', AttachmentDropController);
application.register('markdown-editor', MarkdownEditorController);
application.register('list-sortable', ListSortableController);
application.register('select-navigate', SelectNavigateController);
application.register('label-color', LabelColorController);
application.register('label-picker', LabelPickerController);
